import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@api/client/apiClient';
import { queryKeys } from '@api/queryKeys';
import type { UpdateOperation } from '../types';

export function useTriggerWeekly() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => apiClient.post<UpdateOperation>('/updates/weekly:trigger'),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.updates.operations });
    },
  });
}
